import Vue from 'vue';
import Router from 'vue-router';
import myOrder from '@/router/module/myOrder';
import personalCenter from '@/router/module/personalCenter';
import recharge from '@/router/module/recharge';
Vue.use(Router);

const children = [...myOrder, ...personalCenter, ...recharge]
const router = new Router({
  routes: [
    {
      path: '',
      name: 'login',
      component: resolve => require(['@/views/Login.vue'], resolve)
    },

    {
      path: '/login',
      name: 'login',
      component: resolve => require(['@/views/Login.vue'], resolve)
    },
    {
      path: '/wxlogin/oauth',
      name: 'login',
      component: resolve => require(['@/views/wxlogin/oauth.vue'], resolve)
    },
    {
      path: '/wxlogin/binding',
      name: 'login',
      component: resolve => require(['@/views/wxlogin/binding.vue'], resolve)
    },
    {
      path: '/index',
      name: 'index',
      component: resolve => require(['@/views/Index.vue'], resolve),
      children,
    }
  ],
  mode:'history',
});

export default router;
